import * as React from 'react';
import { Typography } from 'antd';
// import lifeProtection from 'assets/images/lifeProtection.svg';
import { isLocaleEnglish } from 'utils';
import { useTranslation } from 'react-i18next';
import { changeDataFun } from 'utils';
import styled from 'styled-components';
const { Text } = Typography;
type HistoryCardProps = {
  data: {
    productCategoryEn?: string;
    productCategoryTC?: string;
    productName?: string;
    productNameTc?: string;
    insuredName?: string;
    policyNumber?: string;
    receivedDate?: string;
    paymentAmount?: string;
    paymentMethodDesc?: string;
    paymentMethodDescTc?: string;
    paymentIcon?: string;
  };
};
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
  width: 100%;
  @media (min-width: 576px) {
    width: 608px; // 大屏幕時，最大寬度為 608px
  }
`;
export const HistoryCard = (props: HistoryCardProps): JSX.Element => {
  const { i18n } = useTranslation();
  const {
    productCategoryEn,
    productCategoryTC,
    productName,
    productNameTc,
    insuredName,
    policyNumber,
    receivedDate,
    paymentAmount,
    paymentMethodDesc,
    paymentMethodDescTc,
    // paymentIcon,
  } = props.data;
  // const formatCurrency = (number, currency = 'USD', locale = 'en-US') => {
  //   return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(number);
  // };
  return (
    <div
      style={{
        minHeight: '147px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '16px',
        // width: '640px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        // marginTop: '4px',
      }}
    >
      {/* {paymentIcon ? (
        <img src={paymentIcon} width="40" height="40" style={{ border: 'none', marginLeft: 12 }} />
      ) : (
        <img src={lifeProtection} width="40" height="40" style={{ border: 'none', marginLeft: 12 }} />
      )} */}
      <Container
        style={{
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'space-between',
        }}
      >
        <div
          style={{
            width: '100%',
            // background: 'blue',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Text style={{ fontFamily: 'Roboto400', fontSize: '17px', color: '#6F7072' }}>
            {isLocaleEnglish(i18n.language) ? productCategoryEn : productCategoryTC}
          </Text>
          <Text style={{ fontFamily: 'Roboto500', fontSize: '17px', color: '#6F7072' }}>
            {i18n.language == 'en' ? receivedDate || '' : changeDataFun(receivedDate || '')}
          </Text>
        </div>
        <div
          style={{
            width: '100%',
            // background: 'blue',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Text
            style={{ color: '#20252B', fontFamily: 'Roboto400', fontSize: '20px' }}
            // numberOfLines={1}
            // ellipsizeMode="tail"
            // style={{ width: scaleWithDevice(180) }}
          >
            {isLocaleEnglish(i18n.language) ? productName : productNameTc}
          </Text>
          <Text
            style={{
              color: '#20252B',
              fontFamily: 'Roboto400',
              fontSize: '20px',
              // background: 'green',
              textAlign: 'right',
            }}
          >
            {paymentAmount ? paymentAmount : ''}
          </Text>
        </div>
        <div
          style={{
            width: '100%',
            // background: 'blue',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <Text
            style={{ fontFamily: 'Roboto400', fontSize: '17px', color: '#6F7072', maxWidth: 'calc(100% - 107px)' }}
            // numberOfLines={1}
            // ellipsizeMode="tail"
            // style={{ maxWidth: '60%' }}
          >
            {isLocaleEnglish(i18n.language) ? `Insured: ${insuredName}` : `受保人:${insuredName}`}
          </Text>
          <Text
            style={{
              fontFamily: 'Roboto400',
              fontSize: '17px',
              color: '#6F7072',
              minWidth: '107px',
              // background: 'red',
              textAlign: 'right',
            }}
            // numberOfLines={1}
            // ellipsizeMode="tail"
            // style={{ maxWidth: '40%' }}
          >
            {isLocaleEnglish(i18n.language) ? paymentMethodDesc : paymentMethodDescTc}
          </Text>
        </div>
        <Text style={{ display: 'block', fontFamily: 'Roboto400', fontSize: '17px', color: '#6F7072' }}>
          {isLocaleEnglish(i18n.language) ? `Policy no.${policyNumber}` : `保單號碼:${policyNumber}`}
        </Text>
      </Container>
    </div>
  );
};

// const historyCardStyles = {
//   flexrow: {
//     flexDirection: 'row',
//     alignItems: 'center',
//     justifyContent: 'space-around',
//   },
//   flexrow2: {
//     flexDirection: 'row',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//   },
//   warp: {
//     flexWrap: 'wrap',
//   },
//   svgStyle: {
//     width: '15%',
//   },
//   contentStyle: {
//     width: '85%',
//   },
//   cardStyle: {
//     backgroundColor: 'white',
//     borderRadius:10, // 确保 scaleWithDevice 函数返回正确的值
//     shadowColor: '#000',
//     shadowOffset: { width: 0, height: 1 },
//     shadowOpacity: 0.25,
//     shadowRadius: 4,
//     elevation: 4,
//     padding: 10,
//     marginHorizontal: 16,
//     marginBottom: 5,
//   },
// };
